import { EmbedEvent, LiveboardEmbed, MessagePayload } from '@thoughtspot/visual-embed-sdk'
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import EmbeddedContent from '../../components/EmbeddedContent'
import { ALL_HIDDEN_ACTIONS, COMMON_THOUGHTSPOT_ACTIONS } from '../../constants'
import Error404 from '../error/Error404'
import isUUID from 'validator/lib/isUUID'
import { logError } from '../../services/error/logger'

export const kpiEmbedId = 'embed-liveboard'

const Kpi = () => {
  const queryParams = useParams()
  const { dashboardId, kpiId } = queryParams
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    if (kpiId && !isUUID(kpiId) && dashboardId && !isUUID(dashboardId)) {
      setHasError(true)
    }

    const handleError = (messagePayload: MessagePayload) => {
      const embedError = new Error(`Kpi: ${JSON.stringify(messagePayload)}`)
      logError(embedError)
    }

    const embed = new LiveboardEmbed(`#${kpiEmbedId}`, {
      liveboardId: dashboardId,
      vizId: kpiId,
      showLiveboardTitle: true,
      hiddenActions: ALL_HIDDEN_ACTIONS,
      ...COMMON_THOUGHTSPOT_ACTIONS,
    })

    void embed
      .on(EmbedEvent.Error, (messagePayload: MessagePayload) => {
        handleError(messagePayload)
      })
      .render()

    return () => {
      embed.off(EmbedEvent.Error, handleError)
    }
  }, [kpiId, dashboardId])

  if (hasError) {
    return <Error404 />
  }

  return (
    <EmbeddedContent
      id={kpiEmbedId}
      testId={kpiEmbedId}
    />
  )
}

export default Kpi
